export default {
    cancel: 'Agora não',
    title: 'Sempre com você!',
    activate: 'Ativar Notificações',
    error: 'Um erro ocorreu ao ativar o recebimento das mensagens, tente novamente',
    message: 'Gostaria de receber nossos informativos sobre o céu e conteúdos novos?',
};